import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube } from "react-icons/fa";
import Logo from "../assets/logo.png";

const Footer = () => {
  return (
    <footer className="footer bg-light pt-5">
      <Container>
        <Row className="mb-4">
          {/* Logo & Social Icons */}
          <Col md={3} sm={12} className="mb-4">
            <img src={Logo} alt="Thaani Logo" className="mb-3" />
            <div className="d-flex gap-3">
              <a href="#">
                <FaFacebookF size={18} />
              </a>
              <a href="#">
                <FaTwitter size={18} />
              </a>
              <a href="#">
                <FaInstagram size={18} />
              </a>
              <a href="#">
                <FaYoutube size={18} />
              </a>
            </div>
          </Col>

          {/* Important Links */}
          <Col md={3} sm={6} className="mb-3">
            <h6 className="fw-bold">Important</h6>
            <ul className="list-unstyled">
              <li>
                <a href="#">About Us</a>
              </li>
              <li>
                <a href="#">Services</a>
              </li>
              <li>
                <a href="#">Gallery</a>
              </li>
            </ul>
          </Col>

          {/* Quick Links */}
          <Col md={3} sm={6} className="mb-3">
            <h6 className="fw-bold">Quick Links</h6>
            <ul className="list-unstyled">
              <li>
                <a href="#">FAQ’s</a>
              </li>
              <li>
                <a href="#">Terms & Conditions</a>
              </li>
              <li>
                <a href="#">Privacy Policy</a>
              </li>
            </ul>
          </Col>

          {/* Contact Us */}
          <Col md={3} sm={12}>
            <h6 className="fw-bold">Contact Us</h6>
            <address>
              19A, 7A, 1st Floor,<br />
              Vedhathri Nagar, E.B. Road,<br />
              Trichy - 62008, Tamil Nadu.<br />
              <a href="mailto:thaanitamilnadu@gmail.com">
                thaanitamilnadu@gmail.com
              </a>
              <br />
              <a href="tel:+919003510885">+91 - 90035 10885</a>, 0431-2700001
            </address>
          </Col>
        </Row>

        <hr className="text-warning my-3" />

        <div className="text-center pb-3 small">
          © Copyright 2024 Thaani. All Rights Reserved.
        </div>
      </Container>

      {/* Inline Styles */}
      <style>{`
        .footer a {
          text-decoration: none;
          color: #000;
        }

        .footer a:hover {
          text-decoration: underline;
          color: #fcb900;
        }

        .footer svg {
          color: #000;
        }

        .footer svg:hover {
          color: #fcb900;
        }

        address {
          font-style: normal;
          font-size: 0.9rem;
        }
      `}</style>
    </footer>
  );
};

export default Footer;
